import { createSlice } from "@reduxjs/toolkit";

const diseasesSlice = createSlice({
  name: "disease",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    fetchDiseasesStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchDiseaseSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchDiseaseFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchDiseasesStart, fetchDiseaseSuccess, fetchDiseaseFailure } =
  diseasesSlice.actions;
export default diseasesSlice.reducer;
